module.exports = __webpack_public_path__ + "static/muscle-aa51e49bd8ae5067f4e779788ce66459.svg";